import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "budget-chart__title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_EChartsColumnAndLine = _resolveComponent("EChartsColumnAndLine")!
  const _component_ChartContainer = _resolveComponent("ChartContainer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          (_ctx.titleTooltipContent)
            ? (_openBlock(), _createBlock(_component_Tooltip, {
                key: 0,
                class: "tooltip-component--mobile-big"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.titleTooltipContent), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ChartContainer, { class: "budget-chart" }, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
          : (_openBlock(), _createBlock(_component_EChartsColumnAndLine, {
              key: 1,
              xData: _ctx.getXData,
              columnYData: _ctx.getColumnYData,
              columnYName: "Государственный долг, % ВВП",
              lineYData: _ctx.getLineYData,
              lineYName: "Дефицит бюджета, % ВВП",
              formatTooltipFunction: _ctx.formatYLabel,
              formatYLabelFunction: _ctx.formatYLabel
            }, null, 8, ["xData", "columnYData", "lineYData", "formatTooltipFunction", "formatYLabelFunction"]))
      ]),
      _: 1
    })
  ]))
}